import React from 'react';
import styles from './Item.module.scss';
import Shareds from '../../../../../config/translations/Shareds';

function Item({ label, value, col = '4', className = '' }) {
    return (
        <div className={`p-col-${col} ${styles.item} ${className}`}>
            <div className={styles.label}>{label}</div>
            <div className={styles.value}>{value ?? Shareds.naoDefinido}</div>
        </div>
    );
}

export default Item;
